import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import { registerCharts } from './charts.config';

registerLocaleData(localeEnGb, 'en-GB');
registerLocaleData(localeEs, 'es');

registerCharts();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
